module.exports = __webpack_public_path__ + "static/media/howitwork1.2e877389.jpg";